import { render, staticRenderFns } from "./TrySvg.vue?vue&type=template&id=64875728"
import script from "./TrySvg.vue?vue&type=script&lang=js"
export * from "./TrySvg.vue?vue&type=script&lang=js"
import style0 from "./TrySvg.vue?vue&type=style&index=0&id=64875728&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports